import { EMRData, EMRDataStream, EMRDataStreamId } from "../../../../../../../Managers/VisualizationManager/ToolBar/Modals/MedicationGraphModalities/Medications";
import { isGenericAnalytic } from "../../../Types/AnalysisDetails";
import { ModalityGraphConfigJSON } from "../../../Types/Graph";
import { getFullTraceDataConfigs } from "../../../Types/Trace";

export function getVisibleGraphs<T extends ModalityGraphConfigJSON>(graphs: T[], patientModalities: string[], emrData: EMRData[], hideEmptyGraphs: boolean) {
    if (!hideEmptyGraphs) {
        return graphs
    }

    return graphs.filter(graph => graph.traces
        .filter(trace => (trace.isVisible ?? true))
        .flatMap(getFullTraceDataConfigs)
        .some(trace => (
            isEMRDataStreamFound(trace.dataKey, emrData)
            || patientModalities.includes(trace.rawDataKey) 
            || (trace.onDemandAnalysis !== undefined && !isGenericAnalytic(trace.onDemandAnalysis?.analytic))
        ))
    )
}

const isEMRDataStreamFound = (dataKey: string, emrData: EMRData[]): boolean => {
    let parsed: Record<string, any>

    try {
        parsed = JSON.parse(dataKey) as EMRDataStreamId
    } catch { 
        // If the data key is not valid JSON, then it's not EMR data.
        return false
    }

    const { id, code, units } = parsed
    const harmonizedEMRData = emrData.find((emrData: EMRData) => emrData.id === id)

    if (!harmonizedEMRData) {
        return false
    }

    const dataStream = harmonizedEMRData.dataStreams.find((dataStream: EMRDataStream) => dataStream.code === code && dataStream.units === units)

    if (!dataStream) {
        return false
    }

    return true
}